export default Object.freeze({
  UnSet: 0,
  VisitaRegular: 1,
  VisitaReposicion: 2,
  Ausencia: 3,
  Ausencia_Ofrecimiento: 4,
  Visita_Admision: 5,
  Visita_Plan: 6,
  Compensatorio_Reposicion: 7,
  Compensatorio_Regresion: 8,
  VisitaReposicion_AnoAnterior: 9,
  Ausencia_Ofrecimiento_AnoAnterior: 10,
  Compensatorio_Reposicion_Ausencia: 11,
  Visita_Paquete_Plan: 12,
  Visita_Ciberterapia: 13,
  Visita_Presencial_Durante_Emergencia_Covid19: 14,
  Visita_Presencial_Reposicion_Ano_Actual_Covid19: 15,
  Ciberterapia_Reposicion_Ano_Actual: 16,
  Ciberterapia_Reposicion_Ano_Anterior: 17,
  Visita_Presencial_Reposicion_Ano_Anterior_Covid19: 18,
  Ausencia_Ofrecimiento_Reposicion_Ano_Anterior: 19,
  Telepractica_Regresion: 20,
  Presencial_Regresion: 21,
  Ausencia_Especialista: 22,
  Telepractica_Reposicion: 23,
  Presencial_Reposicion: 24,
  Ausencia_Ofrecimiento_Regresion: 25,
  Ausencia_Ofrecimiento_Reposicion: 26,
  Servicio_Presencial: 27,
  Servicio_Virtual: 28,
  VisitaEducativaReposicion: 32,
});
